import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import { setSimpleFilterQuery, setAdvancedFilterQuery } from "src/app/shared/utils/tableUtils";
import { AppState } from "src/app/store/reducers";
import { AppSessionService } from "../../app-session/app-session.service";

const EMPTY_STRING = "";

@Injectable({
  providedIn: "root",
})
export class ProductFamilyService {
    constructor(
        private http: HttpClient,
        private appSession: AppSessionService
      ) {}

      getProductFamilies(
        paging?: any,
        filteringArgs?: any,
        sortingArgs?: any,
        advancedFilteringArgs?: any
      ): Observable<any> {
        let headers = new HttpHeaders({
          "Content-type": "application/json",
        });

        let filterQuery = EMPTY_STRING;
        let advancedFilterQuery = EMPTY_STRING;
        let orderQuery = EMPTY_STRING;

        if (filteringArgs) {
          filterQuery = setSimpleFilterQuery(filteringArgs);
        }

        if (advancedFilteringArgs) {
          advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
        }

        if (sortingArgs) {
          const { active, direction } = sortingArgs;
          orderQuery += active + "," + direction.toUpperCase();
        }

        if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
          headers = headers.append(
            "query",
            `${filterQuery} ${
              filterQuery.length > 0 && advancedFilterQuery.length > 0
                ? FilterOperation.AND
                : ""
            } ${advancedFilterQuery}`
          );
        }

        if (orderQuery.length > 0) {
          headers = headers.append("sort", orderQuery);
        }

        return this.http.get(
          this.buildDataUrl(paging, filteringArgs, sortingArgs, headers, "?"),
          { headers }
        );
      }

      createProductFamily(productFamily): Observable<any> {
        const headers = new HttpHeaders({
            'Content-type': 'application/json'
          });
          const data = JSON.stringify(productFamily);
          const url = `${this.appSession.baseUrl + '/api/v1/products/families'}`;
          return this.http.post(url, data, { headers });
      }

      updateProductFamily(productFamily): Observable<any> {

        const headers = new HttpHeaders({
            'Content-type': 'application/json'
          });
          const data = JSON.stringify(productFamily);
          const url = `${this.appSession.baseUrl + '/api/v1/products/families'}/${productFamily.code}`;
          return this.http.put(url, data, { headers });
      }

      getProductFamily(code): Observable<any> {
        const headers = new HttpHeaders({
          'Content-type': 'application/json'
        });

        const url = `${this.appSession.baseUrl + '/api/v1/products/families'}/${code}`;
        return this.http.get(url, { headers });
      }


  private buildDataUrl(pagingArgs: any, filteringArgs: any, sortingArgs: any, header: HttpHeaders, path: string): string {
    let baseQueryString = `${this.appSession.baseUrl + '/api/v1/products/families'}${path}`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = this._buildScrollExpression(pagingArgs);
    }

    query += (scrollingQuery !== EMPTY_STRING) ? `&${scrollingQuery}` : EMPTY_STRING;

    baseQueryString += query;

    return baseQueryString;
  }

  private _buildScrollExpression(pagingArgs): string {
    const skip = pagingArgs.skip;
    const top = pagingArgs.top;
    const realSize = pagingArgs.realSize;

    if (top && top !== null) {
      return `real_size=${!!realSize}&offset=${skip}&limit=${top}`;
    } else {
      return `real_size=${!!realSize}&offset=${skip}`;
    }
  }
}
